import { useMemo } from 'react';

import { Campaign } from '../../../../core/api/restaurant/restaurant.types';
import { Voucher } from '../../../../core/state/restaurant/restaurant.types';

export const useLoyaltyVouchers = (
  loyaltyCampaigns: Campaign[] = [],
): Voucher[] => {
  const loyaltyVouchers = useMemo(() => {
    const vouchers: Voucher[] = [];

    loyaltyCampaigns.forEach((loyaltyCampaign) => {
      if (loyaltyCampaign.Rewards?.length) {
        const [reward] = loyaltyCampaign.Rewards;
        const isDiscountPercentage = reward.Type === 'PercentageDiscount';

        const discountValue = isDiscountPercentage
          ? `${reward.Value}%`
          : reward.Value;

        const voucher = {
          code: loyaltyCampaign.Voucher.Code,
          description: loyaltyCampaign.Description,
          discountValue,
          expiryDate: loyaltyCampaign.Voucher.ExpireDate,
          startDate: loyaltyCampaign.Voucher.StartDate,
          type: reward.Type,
        };

        vouchers.push(voucher);
      }
    });

    return vouchers;
  }, [loyaltyCampaigns.length]);

  return loyaltyVouchers;
};
